/* jslint esversion: 6 */
/**
 * Header Scripts
 *
 * @package Carbon
 * @subpackage Scripts
 * @since 2.0.0
 */
require('./header/modernizr');



// WEBPACK FOOTER //
// /app/wp-content/themes/partnershipforthefuture/source/scripts/carbon-scripts-header.js